import { Banner, Button, Dropdown } from '@react-apps/design-system';
import { KNOWN_ROLES, ROLE_LABELS } from '@/shared/guards/roles';
import { useViewAsStore } from './view-as.store';
import { useIsRealAdmin } from './use-effective-roles';

/**
 * Faixa no topo avisando que o sys-admin está "visualizando como" um papel, com
 * botão para sair. Só aparece para admin real e quando o modo está ativo.
 */
export function ViewAsBanner() {
  const isRealAdmin = useIsRealAdmin();
  const viewAsRole = useViewAsStore((s) => s.viewAsRole);
  const clearViewAs = useViewAsStore((s) => s.clearViewAs);

  if (!isRealAdmin || !viewAsRole) return null;

  return (
    <Banner tone="warning" actionLabel="Sair" onAction={clearViewAs}>
      Visualizando como <strong>{ROLE_LABELS[viewAsRole] ?? viewAsRole}</strong>{' '}
      <code className="text-xs">({viewAsRole})</code> — gating de UI apenas; o
      backend ainda te vê como admin.
    </Banner>
  );
}

/**
 * Seletor de "visualizar como" no header — só para admin real. Permite testar
 * visualmente as regras de rota/menu de cada papel.
 */
export function ViewAsPicker() {
  const isRealAdmin = useIsRealAdmin();
  const viewAsRole = useViewAsStore((s) => s.viewAsRole);
  const setViewAsRole = useViewAsStore((s) => s.setViewAsRole);
  const clearViewAs = useViewAsStore((s) => s.clearViewAs);

  if (!isRealAdmin) return null;

  const items = [
    ...(viewAsRole
      ? [
          {
            id: '__normal',
            label: 'Visão normal (admin)',
            onClick: clearViewAs,
          },
        ]
      : []),
    ...KNOWN_ROLES.map((role) => ({
      id: role,
      label: `${ROLE_LABELS[role]} (${role})`,
      onClick: () => setViewAsRole(role),
      disabled: role === viewAsRole,
    })),
  ];

  return (
    <Dropdown
      align="right"
      trigger={
        <Button variant="secondary">
          {viewAsRole ? `Vendo: ${ROLE_LABELS[viewAsRole]}` : 'Visualizar como'}
        </Button>
      }
      items={items}
    />
  );
}
